import { useState, useEffect } from "react";
import BaseSubscriptionTab from "./base";
import CustomSubscriptionTab from "./custom";
import { useCommonContext } from "../../utils/context";

const Subscription = () => {
  const [activeTab, setActiveTab] = useState("standard");

  const { subscription, fetchSubscription, subscriptionLoading } =
    useCommonContext();

  useEffect(() => {
    fetchSubscription();
  }, []);

  const calculateDaysLeft = () => {
    if (!subscription?.trial_end_date) return 0;

    const today = new Date();
    const endDate = new Date(subscription.trial_end_date);

    const diff = endDate - today;
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  };

  const daysLeft = calculateDaysLeft();

  return (
    <div className="container mt-4">
      {subscription && (
        <div className="card border-0 shadow-sm mb-3">
          <div className="card-body py-3 px-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <span
                  className={`badge px-3 py-2 rounded-pill ${
                    subscription.status === "trial"
                      ? "bg-warning text-dark"
                      : subscription.status === "active"
                        ? "bg-success"
                        : "bg-danger"
                  }`}
                >
                  {subscription.status.toUpperCase()}
                </span>
                <span className="fw-bold fs-6">
                  {subscription.plan || "No Plan"}
                </span>
                {subscription.status === "trial" && (
                  <span className="text-warning fw-semibold small">
                    {daysLeft > 0 ? `${daysLeft} days left` : "Expired"}
                  </span>
                )}
              </div>
              <small className="text-muted mt-1">
                {subscription.status === "trial" ? (
                  <>
                    {subscription.trial_start_date} →{" "}
                    {subscription.trial_end_date}
                  </>
                ) : (
                  <>
                    {subscription.subscription_start_date || "--"} →{" "}
                    {subscription.subscription_end_date || "--"}
                  </>
                )}
              </small>
            </div>
            <div className="d-flex gap-4 align-items-center flex-wrap">
              <div className="text-center px-3 py-2 rounded-3 bg-light border">
                <div className="fw-bold fs-5 text-primary">
                  {subscription.user_limit || 0}
                </div>
                <small className="text-muted">Users</small>
              </div>
              <div className="text-center px-3 py-2 rounded-3 bg-light border">
                <div className="fw-bold fs-5 text-success">
                  {subscription.sms_limit || 0}
                </div>
                <small className="text-muted">SMS Limit</small>
              </div>
              {subscription.totalCost && (
                <div className="text-center px-3 py-2 rounded-3 bg-light border">
                  <div className="fw-bold fs-5 text-dark">
                    ₹ {subscription.totalCost}
                  </div>
                  <small className="text-muted">
                    {subscription.billingCycle}
                  </small>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="btn-group mb-4">
        <button
          className={`btn ${
            activeTab === "standard" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setActiveTab("standard")}
        >
          Standard Plans
        </button>

        <button
          className={`btn ${
            activeTab === "custom" ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => setActiveTab("custom")}
        >
          Custom Plan
        </button>
      </div>

      <div>
        {activeTab === "standard" && <BaseSubscriptionTab />}
        {activeTab === "custom" && <CustomSubscriptionTab />}
      </div>
    </div>
  );
};

export default Subscription;
